import { alpha } from "@mui/material/styles";

export const clientFormTabShellSx = {
  borderRadius: 2.5,
  overflow: "hidden",
  width: "100%",
  boxShadow: (t) => `0 1px 3px ${alpha(t.palette.common.black, 0.06)}`,
};

export const clientFormTabsSx = {
  px: { xs: 1, md: 2 },
  minHeight: 48,
  bgcolor: "background.paper",
  borderBottom: 1,
  borderColor: "divider",
  "& .MuiTab-root": {
    fontWeight: 600,
    textTransform: "none",
    minHeight: 48,
    fontSize: "0.875rem",
    px: 2,
  },
  "& .Mui-selected": { color: "primary.main" },
};

export const clientFormTabPanelSx = {
  p: { xs: 2, sm: 2.5, md: 3 },
  bgcolor: (t) => alpha(t.palette.background.default, 0.35),
};

export const clientFormSubsectionTitleSx = {
  fontWeight: 700,
  fontSize: "0.8125rem",
  letterSpacing: 0.2,
  color: "text.secondary",
  textTransform: "uppercase",
  mb: 1.5,
  mt: 0,
};

export const clientFormFieldsGridSx = {
  display: "grid",
  gridTemplateColumns: { xs: "1fr", sm: "repeat(12, minmax(0, 1fr))" },
  gap: 2,
  alignItems: "start",
  width: "100%",
};

export const clientFormSectionCardSx = clientFormTabShellSx;
export const clientFormSectionHeaderSx = {};
export const clientFormSectionBodySx = {};
export const CLIENT_FORM_CONTENT_MAX_WIDTH = "100%";
